import { OximeterInputState } from "../components/OxygenInput";

export class OxygenInput {
    constructor(initialValue = 2000) { 
      this.value = initialValue;
      this.listeners = new Set();
      this.increment=this.increment.bind(this)
      this.decrement=this.decrement.bind(this)
      this.setConnectedState=this.setConnectedState.bind(this)
      this.state=OximeterInputState.OXYGEN_CONNECTED

    }
    
    setConnectedState(state) {
      if (state == OximeterInputState.NO_OXYGEN) {
        this.value=0
      }
      else if(state == OximeterInputState.OXYGEN_CONNECTED){
        this.value=2000
      }
      this.state=state
      this._fireChangeEvent();
    }
  
    increment() {
      if(this.value+1*100>2000){
        return;
      }
      this.value+=1*100;
      this._fireChangeEvent()
    }
    decrement() {
      if(this.value-1*100<0){
        return;
      }
      this.value-=1*100;
      this._fireChangeEvent() 
    }

    subscribe(listener) {
      this.listeners.add(listener);
    }
  
    unsubscribe(listener) {
      this.listeners.delete(listener);
    }
  
    _fireChangeEvent() {
      this.listeners.forEach(listener => listener("test"));
    }
  }